import React, { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import SimpleInput from 'src/Components/SimpleInput';
import httpRequest from 'src/helpers/httpRequest';

interface IProps {
    previous: string;
    onSuccess: (val: string) => void;
    uid: string;
};

const DoctorAboutMeEdit: React.FC<IProps> = ({
    previous = "",
    onSuccess = () => { },
    uid,
}) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [aboutMe, setAboutMe] = useState(previous);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setIsLoader(true);
        const { res, err } = await httpRequest<{ message: string; data: string; percent: number }>({
            method: "post",
            path: `/provider/admin/about/${uid}`,
            params: { aboutMe }
        });
        if (res) {
            const { message, data } = res;
            toast(message, { type: "success" }); // api success message
            onSuccess(data);
        } else {
            toast(err, { type: "error" }); // api error
        }
        setIsLoader(false);
    };

    return (
        <>
            <div className="parent-box">
                <p className="font-Poppins-semiBold font-size-18px theme-color-green mb-2">You can write about your years of experience, industry, or skills. People also talk about their achievements or previous job experiences.</p>
                <form onSubmit={handleSubmit}>
                    <SimpleInput
                        isRequired={true}
                        value={aboutMe}
                        onChange={(val) => setAboutMe(val)}
                        type="textArea"
                        rows={10}
                        isLimit={1200}
                        maxLength={1200}
                        extraStyle={{ borderColor: "#009d91" }}
                    />
                    <div className="flex justify-end mt-10">
                        <PrimaryBtn
                            loader={isLoader}
                            type="submit"
                            ButtonText="Save"
                            btnExtraStyle={{
                                borderRadius: "1.5rem",
                                backgroundColor: "#004540"
                            }}
                        />
                    </div>
                </form>
            </div>
        </>
    );
};

export default DoctorAboutMeEdit;